import { render, staticRenderFns } from "./SwitchBiller.vue?vue&type=template&id=696a5d9b"
import script from "./SwitchBiller.vue?vue&type=script&lang=js"
export * from "./SwitchBiller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports